import { render, staticRenderFns } from "./FormAsignacion.vue?vue&type=template&id=c507364a&"
import script from "./FormAsignacion.vue?vue&type=script&lang=js&"
export * from "./FormAsignacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports